/**
 * Occupancy Style02 - Stitch v2: gold theme + card + 光暈光點
 */
import type { TraitControlProps } from './types'
import { getTraitConfig } from './traitStyleConfig'
import './OccupancyStyle02.css'

export function OccupancyStyle02({ device, state }: TraitControlProps) {
  const { icon } = getTraitConfig('Occupancy')
  const deviceName = device?.nickname ?? device?.name ?? device?.displayName ?? ''
  const occupied = (state?.occupancy ?? state?.occupied ?? state?.value ?? state?.motion) as boolean | string | undefined
  const isDetected = occupied === true || occupied === 'OCCUPIED' || occupied === 'occupied' || occupied === 'motion' || occupied === 'MOTION_DETECTED' || String(occupied).toLowerCase() === 'true'

  return (
    <div className="trait-occupancy-style02 trait-stitch-v2-glass">
      <div className="trait-occupancy-style02__content">
        <span className="trait-occupancy-style02__name">{deviceName}</span>
        <span className={`trait-occupancy-style02__status ${isDetected ? 'detected' : ''}`}>
          {isDetected ? 'MOTION DETECTED' : 'No motion'}
        </span>
      </div>
      <div className="trait-occupancy-style02__indicator">
        {isDetected ? (
          <span className="trait-occupancy-style02__glow-dot" aria-hidden />
        ) : (
          <span className="material-symbols-outlined trait-occupancy-style02__icon">{icon}</span>
        )}
      </div>
    </div>
  )
}
